import React from 'react';

interface UnreadSmsBadgeProps {
    count?: number;
}

const UnreadSmsBadge: React.FC<UnreadSmsBadgeProps> = ({ count = 0 }) => {
    if (count <= 0) return null;
    return (
        <span
            title={`${count} unread SMS`}
            style={{
                background: 'var(--color-primary-alpha)',
                color: 'var(--color-neutrals-background)',
                borderRadius: '50%',
                fontSize: '1rem',
                minWidth: '1.6rem',
                height: '1.6rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 700,
                padding: '0 0.3rem'
            }}
        >
            {count}
        </span>
    );
};

export default UnreadSmsBadge;
